import setup_communications_carousel from './libraries/communications-carousel.js';

Promise.all([]).then(() => {
  setup();
  document.addEventListener("remount:homepage", remount);
});

function setup() {
  remount();
}

function remount() {
  setup_communications_carousel();
}
